import { useEffect } from 'react';
export const useInitSurvey = ({ userId, productId, language }) => {
    useEffect(function initSurvicate() {
        const setVisitorTraits = () => {
            window._sva?.setVisitorTraits({
                userId,
                productId,
                language
            });
        };
        const initSurvicate = () => {
            if (window._sva) {
                setVisitorTraits();
            }
            else {
                const handleReady = () => {
                    setVisitorTraits();
                    window.removeEventListener('SurvicateReady', handleReady);
                };
                window.addEventListener('SurvicateReady', handleReady);
            }
        };
        initSurvicate();
    }, [userId, language, productId]);
};
